let url = () =>{
    let url
    if(process.env.NODE_ENV === 'development') {
        url = `https://staging.afcfta.app`
    } else {
        url = `https://staging.afcfta.app`
    }
    return url
}

export default url;